import userState from './userState'
import storeState from './storeState'
import orderState from './orderState'
import homeState from './homeState'

export default {
  ...userState,
  ...storeState,
  ...orderState,
  ...homeState,
  currentStoreInfo: {},                    //集团用户、管理员当前查看的门店
  newMessageInform: {                      //webSocket接收的消息推送
    type: '',
    title: '',
    content: '',
    verify: '',
  },
  wechatInfo: {                            //用户绑定的微信身份
    avatar: '',
    nickName: '',
    openid: ''
  },
  provinceArr: [],                        //数据库省份数据
  cityArr: [],                            //数据库市数组
  districtArr: [],                        //数据库区数组
  elFormValue:{
    max:0,
    min:0,
  },
  //首页
  inquiryList: JSON.parse(localStorage.getItem('inquiryList')) || [],    //询价清单
}
